import React, { Component } from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import { getList } from './erroGeralActions';
import { PAGE_SIZE } from '../common/utils/pageSize';
import TicketSuporteForm from '../ticket_suporte/ticketSuporteForm';
import ProcessingOverlay from '../common/components/processingOverlay';
import axiosInstance from '../main/axios';
import { humanizarMensagemErro, mensagemAtendeBusca } from '../common/utils/erroMensagemUtils';
import {
  OS_STATUS_BADGE,
  OS_STATUS_LABELS,
  TICKET_STATUS_BADGE,
  TICKET_STATUS_LABELS,
} from '../notifications/components/notificationListUtils';
import { openFromNotification } from '../manutencao/ordem_servico/ordemServicoActions';
import { validaPermissao } from '../auth/permissaoActions';
import configLocal from '../configuracao/configLocal';

moment.locale('pt-br');

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const printButtonStyle = {
  height: '32px',
  width: '32px',
  padding: 0,
  border: '1px solid #bfd0e0',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#475569',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

const defaultDataInicio = () =>
  moment()
    .subtract(1, 'day')
    .format('YYYY-MM-DD');
const defaultDataFim = () => moment().format('YYYY-MM-DD');

const dateInputStyle = {
  width: '150px',
  height: '32px',
  padding: '4px 8px',
  fontSize: '12px',
  border: '1px solid #bfd0e0',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#475569',
};

const messageInputStyle = {
  width: '220px',
  height: '32px',
  padding: '4px 10px',
  fontSize: '12px',
  border: '1px solid #bfd0e0',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#475569',
};

class ControladorErroGeralList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      pages: null,
      loading: true,
      dataInicio: defaultDataInicio(),
      dataFim: defaultDataFim(),
      buscaMensagem: '',
      tablePage: 0,
      showTicketModal: false,
      selectedError: null,
      abrindoOs: false,
    };

    this.fetchData = this.fetchData.bind(this);
    this.filtrarLista = this.filtrarLista.bind(this);
    this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    this.handleBuscaMensagemChange = this.handleBuscaMensagemChange.bind(this);
    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleOpenExistingTicket = this.handleOpenExistingTicket.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);
    this.handleTablePageChange = this.handleTablePageChange.bind(this);
    this.handleShowOs = this.handleShowOs.bind(this);
    this.buildErrorAsNotification = this.buildErrorAsNotification.bind(this);
    this.imprimirRelatorio = this.imprimirRelatorio.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.onDataLoaded && prevProps.data !== this.props.data) {
      this.props.onDataLoaded();
    }
  }

  fetchData(overrides = {}) {
    this.setState({ loading: true });

    const dataInicio = overrides.dataInicio != null ? overrides.dataInicio : this.state.dataInicio;
    const dataFim = overrides.dataFim != null ? overrides.dataFim : this.state.dataFim;

    this.props.getList(0, [], [], dataInicio, dataFim).then(() => {
      this.setState({ loading: false });
    });
  }

  filtrarLista(lista) {
    const termoBusca = (this.state.buscaMensagem || '').trim();
    if (!termoBusca) return lista || [];

    return (lista || []).filter(row => {
      const mensagemExibicao =
        row.mensagem_humana || humanizarMensagemErro(row.mensagem) || row.mensagem || '';
      return mensagemAtendeBusca(mensagemExibicao, termoBusca);
    });
  }

  handleDateRangeChange(field, value) {
    this.setState({ [field]: value, tablePage: 0 }, () => {
      this.fetchData({ [field]: value });
    });
  }

  handleBuscaMensagemChange(event) {
    this.setState({ buscaMensagem: event.target.value, tablePage: 0 });
  }

  handleTablePageChange(page) {
    this.setState({ tablePage: page });
  }

  getTicketInfo(error) {
    if (!error) return null;
    if (error.ticket_id) {
      return {
        id: error.ticket_id,
        status: error.ticket_status,
        titulo: error.ticket_titulo,
      };
    }
    return null;
  }

  getOsInfo(error) {
    if (!error || !error.os_id) return null;
    return {
      id: error.os_id,
      numero: error.os_numero,
      status: error.os_status,
    };
  }

  buildErrorAsNotification(error) {
    return {
      id_erro: error.id_erro,
      id: error.id_erro,
      controlador_id: error.controlador_id,
      grupo_fisico_id: error.grupo_fisico_id,
      numero_controlador: error.numero_controlador,
      mensagem: error.mensagem_humana || humanizarMensagemErro(error.mensagem) || error.mensagem,
      data_erro: error.data_erro,
      hora_erro: error.hora_erro,
    };
  }

  handleShowOs(error) {
    if (this.state.abrindoOs) return;

    const osInfo = this.getOsInfo(error);
    this.setState({ abrindoOs: true });
    this.props
      .openFromNotification(this.buildErrorAsNotification(error), osInfo)
      .then(() => {
        if (this.props.history) {
          this.props.history.push('/manutencao-os');
        }
      })
      .finally(() => this.setState({ abrindoOs: false }));
  }

  handleOpenExistingTicket(error, ticketInfo) {
    if (!ticketInfo || !ticketInfo.id) return;

    axiosInstance
      .get(`/ticket_suporte/${ticketInfo.id}`)
      .then(resp => {
        const ticket = resp.data || {};
        this.setState({
          showTicketModal: true,
          selectedError: {
            id: ticket.id,
            titulo: ticket.titulo || '',
            descricao: ticket.descricao || '',
            status: ticket.status || 'ABERTO',
            controlador_id: ticket.controlador_id || error.controlador_id || '',
            grupo_fisico_id: ticket.grupo_fisico_id || error.grupo_fisico_id,
            numero_controlador: error.numero_controlador,
            controlador_erro_id: ticket.controlador_erro_id || error.id_erro,
            isFromError: false,
          },
        });
      })
      .catch(() => {
        this.setState({
          showTicketModal: true,
          selectedError: {
            id: ticketInfo.id,
            titulo: ticketInfo.titulo || `Ticket #${ticketInfo.id}`,
            descricao: '',
            status: ticketInfo.status || 'ABERTO',
            controlador_id: error.controlador_id || '',
            grupo_fisico_id: error.grupo_fisico_id,
            numero_controlador: error.numero_controlador,
            controlador_erro_id: error.id_erro,
            isFromError: false,
          },
        });
      });
  }

  handleShowTicketModal(error) {
    this.setState({
      showTicketModal: true,
      selectedError: {
        titulo: `Erro no Controlador ${error.numero_controlador}`,
        descricao: `Mensagem de Erro: ${error.mensagem_humana || error.mensagem}

Detalhes:
- Data: ${moment(error.data_erro).format('DD/MM/YYYY')}
- Hora: ${error.hora_erro}
- Controlador: ${error.numero_controlador}
- Grupo Físico: ${error.grupo_fisico_id}`,
        grupo_fisico_id: error.grupo_fisico_id,
        numero_controlador: error.numero_controlador,
        controlador_erro_id: error.id_erro,
        controlador_id: error.controlador_id || '',
        isFromError: true,
      },
    });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedError: null }, () => {
      this.fetchData();
    });
  }

  imprimirRelatorio() {
    const listaFiltrada = this.filtrarLista(this.props.data || []);
    if (!listaFiltrada.length) {
      alert('Nenhum dado para imprimir com os filtros atuais.');
      return;
    }

    const { dataInicio, dataFim, buscaMensagem } = this.state;
    const { config } = this.props;
    const grupoId = configLocal.getConfig('grupo');
    const controladorNum = configLocal.getConfig('numCont');
    const usaTickets = config && config.modulo_tickets;
    const usaManutencao = config && config.modulo_manutencao && validaPermissao('CadOrdemServico');

    const grupoLabel = !grupoId || grupoId === 0 || grupoId === '0' ? 'Todos' : String(grupoId);
    const controladorLabel =
      !controladorNum || controladorNum === 0 || controladorNum === '0' ? 'Todos' : String(controladorNum);

    let printWindow = null;

    try {
      printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Não foi possível abrir a janela de impressão. Verifique o bloqueador de pop-ups.');
        return;
      }

      const formatTicketCol = error => {
        const ticket = this.getTicketInfo(error);
        if (!ticket) return '—';
        const statusLabel = TICKET_STATUS_LABELS[ticket.status] || ticket.status;
        return `#${ticket.id} · ${statusLabel}`;
      };

      const formatOsCol = error => {
        const os = this.getOsInfo(error);
        if (!os) return '—';
        const statusLabel = OS_STATUS_LABELS[os.status] || os.status;
        return `${os.numero} · ${statusLabel}`;
      };

      let rowsHtml = '';
      listaFiltrada.forEach(row => {
        const mensagem = row.mensagem_humana || humanizarMensagemErro(row.mensagem) || row.mensagem || '';
        rowsHtml += `
          <tr>
            <td>${escapeHtml(moment(row.data_erro).format('DD/MM/YYYY'))}</td>
            <td>${escapeHtml(row.hora_erro || '')}</td>
            <td style="text-align:left;">${escapeHtml(mensagem)}</td>
            <td>${escapeHtml(row.grupo_fisico_id)}</td>
            <td>${escapeHtml(row.numero_controlador)}</td>
            ${usaManutencao ? `<td>${escapeHtml(formatOsCol(row))}</td>` : ''}
            ${usaTickets ? `<td>${escapeHtml(formatTicketCol(row))}</td>` : ''}
          </tr>
        `;
      });

      const filtroMensagem = (buscaMensagem || '').trim()
        ? `<p><strong>Busca:</strong> ${escapeHtml(buscaMensagem.trim())}</p>`
        : '';

      const html = `
        <html>
          <head>
            <title>Notificações</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; color: #333; font-size: 11px; }
              h2 { margin-bottom: 8px; }
              p { margin: 4px 0; }
              table { width: 100%; border-collapse: collapse; margin-top: 16px; }
              th, td { border: 1px solid #ddd; padding: 6px; text-align: center; }
              th { background: #f2f2f2; font-weight: bold; }
            </style>
          </head>
          <body>
            <h2>Notificações</h2>
            <p><strong>Grupo Físico:</strong> ${escapeHtml(grupoLabel)}</p>
            <p><strong>Controlador:</strong> ${escapeHtml(controladorLabel)}</p>
            <p><strong>Período:</strong> ${escapeHtml(moment(dataInicio).format('DD/MM/YYYY'))} a ${escapeHtml(moment(dataFim).format('DD/MM/YYYY'))}</p>
            ${filtroMensagem}
            <p><strong>Registros:</strong> ${listaFiltrada.length}</p>
            <table>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Mensagem</th>
                  <th>Grupo</th>
                  <th>Controlador</th>
                  ${usaManutencao ? '<th>OS</th>' : ''}
                  ${usaTickets ? '<th>Ticket</th>' : ''}
                </tr>
              </thead>
              <tbody>${rowsHtml}</tbody>
            </table>
          </body>
        </html>
      `;

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      setTimeout(() => {
        try {
          printWindow.print();
        } catch (e) {}
        try {
          printWindow.close();
        } catch (e) {}
      }, 50);
    } catch (error) {
      console.error('Erro ao imprimir notificações:', error);
      if (printWindow && !printWindow.closed) {
        try {
          printWindow.close();
        } catch (e) {}
      }
      alert('Erro ao gerar impressão. Tente novamente.');
    }
  }

  renderTicketCell(error) {
    const ticketInfo = this.getTicketInfo(error);

    if (ticketInfo) {
      const badgeClass = TICKET_STATUS_BADGE[ticketInfo.status] || 'ticket-badge--gray';
      const statusLabel = TICKET_STATUS_LABELS[ticketInfo.status] || ticketInfo.status;
      return (
        <button
          type="button"
          className={`notif-modal-os-badge notif-modal-os-badge--linked notif-modal-os-badge--btn erro-geral-grid-badge ${badgeClass}`}
          onClick={() => this.handleOpenExistingTicket(error, ticketInfo)}
          title={`Ticket #${ticketInfo.id} · ${statusLabel}`}
        >
          <span className="notif-modal-os-badge-label">
            <i className="fa fa-ticket-alt" aria-hidden="true" /> #{ticketInfo.id} · {statusLabel}
          </span>
          <i className="fa fa-chevron-right notif-modal-os-badge-arrow" aria-hidden="true" />
        </button>
      );
    }

    return (
      <button
        type="button"
        className="notif-modal-os-badge notif-modal-os-badge--none notif-modal-os-badge--btn erro-geral-grid-badge"
        onClick={() => this.handleShowTicketModal(error)}
        title="Abrir ticket de suporte"
      >
        <span className="notif-modal-os-badge-status">
          <i className="fa fa-ticket-alt" aria-hidden="true" />
          Abrir ticket
        </span>
        <i className="fa fa-chevron-right notif-modal-os-badge-arrow" aria-hidden="true" />
      </button>
    );
  }

  renderOsCell(error) {
    const { abrindoOs } = this.state;
    const osInfo = this.getOsInfo(error);

    if (osInfo) {
      const badgeClass = OS_STATUS_BADGE[osInfo.status] || 'os-badge--gray';
      const statusLabel = OS_STATUS_LABELS[osInfo.status] || osInfo.status;
      return (
        <button
          type="button"
          className={`notif-modal-os-badge notif-modal-os-badge--linked notif-modal-os-badge--btn erro-geral-grid-badge ${badgeClass}`}
          onClick={() => this.handleShowOs(error)}
          disabled={abrindoOs}
          title={`OS ${osInfo.numero} · ${statusLabel}`}
        >
          <span className="notif-modal-os-badge-label">
            <i className="fa fa-clipboard-list" aria-hidden="true" /> {osInfo.numero} · {statusLabel}
          </span>
          <i className="fa fa-chevron-right notif-modal-os-badge-arrow" aria-hidden="true" />
        </button>
      );
    }

    return (
      <button
        type="button"
        className="notif-modal-os-badge notif-modal-os-badge--none notif-modal-os-badge--btn erro-geral-grid-badge"
        onClick={() => this.handleShowOs(error)}
        disabled={abrindoOs}
        title="Abrir ordem de serviço"
      >
        <span className="notif-modal-os-badge-status">
          <i className="fa fa-clipboard-list" aria-hidden="true" />
          Abrir OS
        </span>
        <i className="fa fa-chevron-right notif-modal-os-badge-arrow" aria-hidden="true" />
      </button>
    );
  }

  render() {
    moment.locale('pt-br');
    const { data, total, config } = this.props;
    const usaTickets = config && config.modulo_tickets;
    const usaManutencao = config && config.modulo_manutencao && validaPermissao('CadOrdemServico');
    const listaFiltrada = this.filtrarLista(data);

    const columns = [
      {
        Header: 'Data',
        accessor: 'data_erro',
        width: 135,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
      },
      {
        Header: 'Hora',
        accessor: 'hora_erro',
        width: 110,
        className: 'column_grid column_center',
        filterable: false,
        resizable: true,
      },
      {
        Header: 'Mensagem',
        accessor: 'mensagem',
        width: 460,
        filterable: false,
        resizable: true,
        className: 'column_grid column_left erro-geral-col-mensagem',
        Cell: ({ original }) => {
          const texto =
            original.mensagem_humana || humanizarMensagemErro(original.mensagem) || '-';
          return (
            <span className="erro-geral-mensagem-cell" title={texto}>
              {texto}
            </span>
          );
        },
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_fisico_id',
        width: 95,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
      },
      {
        Header: 'Controlador',
        accessor: 'numero_controlador',
        width: 120,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
      },
    ];

    if (usaManutencao) {
      columns.push({
        Header: 'OS',
        accessor: 'os_id',
        width: 128,
        className: 'column_grid column_center',
        filterable: false,
        resizable: false,
        Cell: ({ original: error }) => this.renderOsCell(error),
      });
    }

    if (usaTickets) {
      columns.push({
        Header: 'Ticket',
        accessor: 'ticket_id',
        width: 128,
        className: 'column_grid column_center',
        filterable: false,
        resizable: false,
        Cell: ({ original: error }) => this.renderTicketCell(error),
      });
    }

    const { selectedError } = this.state;

    const showLoading = this.state.loading || this.props.forceLoading;

    const toolbarFilters = (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <input
          type="text"
          value={this.state.buscaMensagem}
          onChange={this.handleBuscaMensagemChange}
          placeholder="Buscar mensagem..."
          style={messageInputStyle}
        />
        <label style={{ fontSize: '12px', color: '#64748b', margin: 0, fontWeight: 600 }}>De</label>
        <input
          type="date"
          value={this.state.dataInicio}
          onChange={e => this.handleDateRangeChange('dataInicio', e.target.value)}
          style={dateInputStyle}
        />
        <label style={{ fontSize: '12px', color: '#64748b', margin: 0, fontWeight: 600 }}>Até</label>
        <input
          type="date"
          value={this.state.dataFim}
          onChange={e => this.handleDateRangeChange('dataFim', e.target.value)}
          style={dateInputStyle}
        />
        <button
          type="button"
          className="btn btn-default"
          title="Imprimir lista filtrada"
          onClick={this.imprimirRelatorio}
          disabled={showLoading}
          style={printButtonStyle}
        >
          <i className="fa fa-print" aria-hidden="true" />
        </button>
      </div>
    );

    return (
      <div>
        <ProcessingOverlay
          show={showLoading}
          message={
            <>
              Carregando notificações...
              <small>Aguarde enquanto os registros são consultados.</small>
            </>
          }
          tagline="Notificações"
        />

        <style>{`
          .erro-geral-premium-table .ReactTable .rt-th.column_left,
          .erro-geral-premium-table .ReactTable .rt-td.column_left {
            justify-content: flex-start;
            text-align: left;
          }

          .erro-geral-premium-table .ReactTable .rt-td.erro-geral-col-mensagem {
            overflow: hidden;
            min-width: 0;
          }

          .erro-geral-premium-table .erro-geral-mensagem-cell {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
            min-width: 0;
          }

          .erro-geral-premium-table .ReactTable .rt-th.column_left .rt-resizable-header-content,
          .erro-geral-premium-table .ReactTable .rt-th.column_left .rt-th-content {
            width: 100%;
            text-align: left;
            justify-content: flex-start;
          }

          .erro-geral-premium-table .erro-geral-grid-badge {
            width: auto;
            max-width: 118px;
            min-height: 28px;
            height: auto;
            padding: 5px 8px;
            font-size: 11px;
            font-weight: 600;
            gap: 5px;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            line-height: 1.25;
            white-space: normal;
          }

          .erro-geral-premium-table .erro-geral-grid-badge .notif-modal-os-badge-label,
          .erro-geral-premium-table .erro-geral-grid-badge .notif-modal-os-badge-status {
            font-size: 11px;
            line-height: 1.25;
            justify-content: center;
            text-align: center;
            gap: 4px;
          }

          .erro-geral-premium-table .erro-geral-grid-badge .notif-modal-os-badge-status i,
          .erro-geral-premium-table .erro-geral-grid-badge .notif-modal-os-badge-label i {
            font-size: 11px;
            flex-shrink: 0;
          }

          .erro-geral-premium-table .erro-geral-grid-badge .notif-modal-os-badge-arrow {
            display: none;
          }
        `}</style>
        <div className="erro-geral-premium-table">
          <PremiumTableShell
            summary={`${listaFiltrada.length} registro(s) exibido(s), ${total || 0} erros no período selecionado`}
            tableMinWidth={1280}
            toolbarRight={toolbarFilters}
          >
            <ReactTableGT2A
              data={listaFiltrada}
              columns={columns}
              filterable={false}
              className="-striped -highlight"
              defaultPageSize={PAGE_SIZE}
              showPaginationBottom={true}
              page={this.state.tablePage}
              onPageChange={this.handleTablePageChange}
            />
          </PremiumTableShell>
        </div>
        {usaTickets && this.state.showTicketModal && selectedError && (
          <TicketSuporteForm
            key={selectedError.id || selectedError.controlador_erro_id || 'new-ticket'}
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={selectedError}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getList, openFromNotification }, dispatch);

export default withRouter(
  connect(
    state => ({
      config: state.auth.config,
      data: state.controladorErroGeralCad.list,
      total: state.controladorErroGeralCad.total,
    }),
    mapDispatchToProps,
  )(ControladorErroGeralList),
);
